import PropTypes from 'prop-types';
import { useDrop } from 'react-dnd-cjs';
import { useSelector } from 'react-redux';

import { CardDropField, codelistProvider } from 'components';
import { codelists } from 'constants/codelists';
import { dragItems } from 'constants/general';
import campaignState from 'features/views/campaignSettings/states';

import SidebarDraggableItem from './SidebarDraggableItem';

const containerId = 'campaign-states-sidebar';

const SidebarDragContainer = ({ onClick, onDrop, contactStatesCodelist = [] }) => {
	const unselectedStates = useSelector((state) =>
		campaignState.selectors.getUnselectedStates(state, contactStatesCodelist),
	);

	const [{ canDrop }, drop] = useDrop({
		accept: dragItems.CAMPAIGN_STATE,
		canDrop: (item) => !item.payload.isDefault && containerId !== item.containerId,
		drop: (item) => {
			if (!item.payload.isDefault && containerId !== item.containerId) {
				onDrop(item.payload.id);
			}
		},
		collect: (monitor) => ({
			canDrop: monitor.canDrop(),
		}),
	});

	return (
		<div ref={drop}>
			{unselectedStates.map((state) => {
				return (
					<SidebarDraggableItem key={state.id} containerId={containerId} state={state} onClick={onClick} />
				);
			})}
			<div style={{ margin: '5px' }}>{canDrop && <CardDropField animate />}</div>
		</div>
	);
};

SidebarDragContainer.propTypes = {
	contactStatesCodelist: PropTypes.arrayOf(PropTypes.object),
	onClick: PropTypes.func,
	onDrop: PropTypes.func,
};

export default codelistProvider(codelists.solutionState, 'contactStatesCodelist')(SidebarDragContainer);
